import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {SavedSearchesQuery} from 'search/saved-searches/__generated/SavedSearchesQuery';
import {SAVED_SEARCHES_QUERY} from 'search/saved-searches/SavedSearchesQuery';
import {SavedSearch} from 'search/saved-searches/SavedSearchUtil';

// Fetches the current user's readable saved searches for name-matching in the omnibox. The omnibox
// filters and caps these client-side (see buildSavedSearchActions), mirroring the Saved Searches
// modal. Fetches fresh on each open (like the modal, which refetches on mount): saved-search
// create/delete/share flows invalidate the section-specific query, not this all-searches query, so a
// cached list would keep showing deleted/revoked searches and omit newly created/shared ones.
export async function fetchOmniboxSavedSearches(): Promise<Array<SavedSearch>> {
  const data = await doQuerySafe<SavedSearchesQuery>(
    {query: SAVED_SEARCHES_QUERY},
    {fetchPolicy: 'network-only'}
  );
  return data.savedSearches;
}
